import api from './api';

export const getTicketStatus = (config) => {
    let errors = [];
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Ticket/GetTicketStatus`, config);
    }
}

export const updateTicketStatus = (ticket, selectedStatus, config) => {
    let errors = [];
    if (!ticket) {
        errors.push('ticket');
    }
    if (!selectedStatus) {
        errors.push('selected status');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.put(`/Ticket/UpdateStatus/${ticket.id}/${selectedStatus}`, {}, config);
    }
}

export const addTicketComment = (user, ticket, title, description, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!ticket) {
        errors.push('ticket');
    }
    // if (!title) {
    //     errors.push('title');
    // }
    if (!description) {
        errors.push('description');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.post(`/Ticket/AddTicketComment/${user.id}/${ticket.id}`, { title, description }, config);
    }
}
